import { FETCH_TUTORIAL_LIST } from './constants'

const initialState = {
  tutorials: [],
  isFetching: false
}

export default function tutorialListReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TUTORIAL_LIST.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case FETCH_TUTORIAL_LIST.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        tutorials: action.tutorials
      }
    }
    default: {
      return state
    }
  }
}
